import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { ApiService } from 'src/app/core/net/apiRoute';
import { distinctUntilChanged, debounceTime, switchMap, map, subscribeOn, first } from 'rxjs/operators';
import { icons } from '../../../icons-provider.module';


@Component({
  selector: 'app-select-icons',
  templateUrl: './app-select-icons.component.html',
  styleUrls: ['./app-select-icons.component.css']
})

export class AppSelectIconsComponent implements OnInit {
  @Output() iconName: EventEmitter<string> = new EventEmitter(); // 输出属性 图标
  @Output() notice:EventEmitter<string> = new EventEmitter();      // 事件参数
  iconlist:any = [];      // outline 图标列表 对应文件在 '/app/icons-provider.module'中添加和导出

  constructor() {
    this.iconlist = icons;
  }

  ngOnInit(): void {

  }

  // 点击图标 返回图标名称
  choose(e){
      this.iconName.emit(e.name);
      this.notice.emit("close");
  }
}
